import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'tailwindcss/tailwind.css';

const App = () => {
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);  // Changed to an array

  useEffect(() => {
    const googleSheetsURL = 'https://docs.google.com/spreadsheets/d/1NOOuc1UpNrHQFpQ6TCQdBSbXVywHQ8wR_WB1uXwJ0sQ/gviz/tq?tqx=out:json'; // Replace {spreadsheetId} with your sheet's id.

    axios.get(googleSheetsURL)
      .then((response) => {
        let data = response.data.slice(response.data.indexOf("{"), response.data.lastIndexOf("}") + 1);
        let json = JSON.parse(data);
        let rows = json.table.rows;
        let formattedData = rows.map((row) => {
          let item = {};
          let columnNames = {};
          json.table.cols.forEach((col, index) => {
            let label = col.label;
            if (!columnNames[label]) {
              columnNames[label] = true;
              item[label] = row.c[index] ? row.c[index].v : null;
            }
          });
          return item;
        });
        setData(formattedData);
      });
  }, []);

  useEffect(() => {
    if (searchTerm === "") {
      setSearchResults(data.filter(item => item.Status === "Public"));
      return;
    }
    setSearchResults(data.filter(item => item.Status === "Public" && item.Name.toLowerCase().includes(searchTerm.toLowerCase())));
  }, [searchTerm, data]);

  const handleSearch = event => {
    setSearchTerm(event.target.value);
  }

  const handleSelect = item => {
    if (selectedItems.includes(item.Name)) {
      setSelectedItems(prev => prev.filter(name => name !== item.Name)); // Remove the item if it's already selected
    } else {
      setSelectedItems([...selectedItems, item.Name]); // Add the item if it's not selected
    }
  }

  return (
    <div className="App bg-gray-300 text-black min-h-screen p-4">
      <input
        type="text"
        placeholder="Search Integrations"
        value={searchTerm}
        onChange={handleSearch}
        className="p-2 rounded border-none bg-gray-200 text-black mb-4 w-full"
      />
      {searchResults.map((item, index) => {
        if (selectedItems.includes(item.Name)) {
          return (
            <div key={index} onClick={() => handleSelect(item)} className="p-4 rounded border-none bg-gray-200 text-black mb-2">
              <h2 className="text-2xl font-bold mb-2">{item.Name}</h2>
              {item.Manufacturer && <p>Manufacturer: {item.Manufacturer}</p>}
              {item['Integration Type'] && <p><strong>Integration Type:</strong> {item['Integration Type']}</p>}
              {item['Class'] && <p><strong>Class:</strong> {item['Class']}</p>}
              {item['Description'] && <p><strong>Description:</strong> {item['Description']}</p>}
              {item['Notes'] && <p><strong>Notes:</strong> {item['Notes']}</p>}
              <h3 className="text-xl font-bold mb-2 mt-4">Supported Features for this Integration Type:</h3>
              {Object.entries(item).map(([key, value], innerIndex) => {
                if (typeof value === 'string' && value.toLowerCase().includes('x') && value.length < 3) {
                  return (<p key={innerIndex}>{key}</p>);
                }
                return null;
              })}
              {item['Support Page'] && (
                <p className="mt-4">
                  For detailed information on the available functionality and device configuration for this integration, please visit the <a href={item['Support Page']} target="_blank" rel="noreferrer" className="underline text-blue-500">Support Page</a>
                </p>
              )}
            </div>
          );
        }
        return (
          <div
            key={index}
            onClick={() => handleSelect(item)}
            className="p-2 rounded border-none bg-gray-200 text-black mb-2 cursor-pointer"
          >
            {item.Name}
          </div>
        );
      })}
    </div>
  );
}

export default App;